/**
 * What a member is called on screen (#1815). The API resolves `displayName`: the member's own name, or, while they
 * have none, the title of a role they hold, so the COO an enterprise is made with reads "COO" until #1740 names it.
 * A member read from a route that does not resolve it falls back to their stored name.
 */
export function memberLabel(member: { name: string; displayName?: string | null }): string {
    return member.displayName?.trim() || member.name
}
